module.exports = __webpack_public_path__ + "static/media/negative.2891d4e8.png";